/* Lasclay : visite des champs et photothèque.
   Vanilla JS, aucune dépendance. Chaque composant s'initialise une seule fois,
   y compris quand l'éditeur de thème recharge une section (shopify:section:load). */
(function () {
  'use strict';

  var mqReduit = window.matchMedia('(prefers-reduced-motion: reduce)');
  var economie = !!(navigator.connection && navigator.connection.saveData);
  var sansMouvement = function () { return mqReduit.matches || economie; };
  var enAnglais = (document.documentElement.lang || '').slice(0, 2) === 'en';
  var T = enAnglais
    ? { fermer: 'Close', prec: 'Previous', suiv: 'Next', telecharger: 'Download', sur: 'of', tout: 'All', glisser: 'Move your mouse to look around' }
    : { fermer: 'Fermer', prec: 'Précédente', suiv: 'Suivante', telecharger: 'Télécharger', sur: 'sur', tout: 'Tout', glisser: 'Bougez la souris pour regarder autour' };

  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function once(el, key) { if (el['__lv' + key]) return false; el['__lv' + key] = true; return true; }

  /* ------------------------------------------------------------------
     Vidéos : source choisie selon l'écran, chargée seulement à l'écran,
     une seule lecture à la fois dans une même scène.
  ------------------------------------------------------------------ */
  /* Sur téléphone, le flux adaptatif (HLS) de Shopify règle la qualité selon le réseau :
     le fichier MP4 servi en boutique est toujours la version la plus lourde. HLS n'est
     retenu que là où le navigateur le lit sans bibliothèque (Safari, Chrome Android). */
  var hlsNatif = null;
  function lectureHls() {
    if (hlsNatif === null) {
      var t = document.createElement('video');
      hlsNatif = !!(t.canPlayType && t.canPlayType('application/vnd.apple.mpegurl'));
    }
    return hlsNatif;
  }
  function petitEcran() { return window.innerWidth < 768; }
  function choisirSource(video) {
    var brut = (video.getAttribute('data-lv-sources') || '').split(';').filter(Boolean);
    var sources = brut.map(function (s) { var i = s.indexOf('|'); var cle = s.slice(0, i); return { hls: cle === 'hls', h: parseInt(cle, 10) || 0, url: s.slice(i + 1) }; }).filter(function (s) { return s.url; });
    var hls = sources.filter(function (s) { return s.hls; })[0];
    if (hls && petitEcran() && lectureHls()) return hls.url;
    sources = sources.filter(function (s) { return !s.hls; });
    if (!sources.length) return null;
    var cible = petitEcran() ? 720 : 1080;
    var shopify = sources.filter(function (s) { return s.h > 0; }).sort(function (a, b) { return a.h - b.h; });
    if (shopify.length) {
      for (var i = 0; i < shopify.length; i++) if (shopify[i].h >= cible) return shopify[i].url;
      return shopify[shopify.length - 1].url;
    }
    return sources[0].url;
  }
  function jouer(video) {
    if (sansMouvement()) return;
    if (!video.getAttribute('src')) {
      var url = choisirSource(video);
      if (!url) return;
      video.src = url;
      video.addEventListener('playing', function () { video.classList.add('is-playing'); });
    }
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }
  function arreter(video) { if (!video.paused) video.pause(); }

  var obsVideo = 'IntersectionObserver' in window ? new IntersectionObserver(function (entrees) {
    entrees.forEach(function (e) {
      var v = e.target;
      if (v.closest('.lv-chapitre__couche')) return; // géré par le chapitre
      if (e.isIntersecting) jouer(v); else arreter(v);
    });
  }, { rootMargin: '10% 0px' }) : null;

  function initVideos(root) {
    $$('[data-lv-video]', root).forEach(function (v) {
      if (!once(v, 'video')) return;
      v.muted = true;
      if (obsVideo) obsVideo.observe(v);
    });
  }

  /* ------------------------------------------------------------------
     Apparition au défilement
  ------------------------------------------------------------------ */
  var obsReveal = 'IntersectionObserver' in window ? new IntersectionObserver(function (entrees) {
    entrees.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); obsReveal.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -10% 0px' }) : null;
  function initReveal(root) {
    $$('[data-lv-reveal]', root).forEach(function (el) {
      if (!once(el, 'reveal')) return;
      if (obsReveal && !sansMouvement()) obsReveal.observe(el); else el.classList.add('is-in');
    });
  }

  /* ------------------------------------------------------------------
     Chapitre : chaque carte peut changer le média de fond
  ------------------------------------------------------------------ */
  function initChapitres(root) {
    $$('[data-lv-chapitre-scene]', root).forEach(function (chap) {
      if (!once(chap, 'chap')) return;
      var couches = $$('.lv-chapitre__couche', chap);
      var cartes = $$('.lv-carte', chap);
      var actif = -1;
      function activer(idx) {
        var couche = 0;
        for (var i = idx; i >= 0; i--) { var c = cartes[i] && cartes[i].getAttribute('data-lv-couche'); if (c) { couche = parseInt(c, 10); break; } }
        cartes.forEach(function (c, i) { c.classList.toggle('is-active', i === idx); });
        couches.forEach(function (c, i) {
          var on = i === couche;
          c.classList.toggle('is-active', on);
          var v = c.querySelector('[data-lv-video]');
          if (v) { if (on && chapVisible) jouer(v); else arreter(v); }
        });
        chap.classList.toggle('has-scrolled', idx >= 0);
        actif = idx;
      }
      var chapVisible = false;
      if (!('IntersectionObserver' in window)) { activer(0); return; }
      new IntersectionObserver(function (e) {
        chapVisible = e[0].isIntersecting;
        if (chapVisible) requestAnimationFrame(mesurer);
        couches.forEach(function (c) { var vid = c.querySelector('[data-lv-video]'); if (vid) { if (chapVisible && c.classList.contains('is-active')) jouer(vid); else arreter(vid); } });
      }, { threshold: 0 }).observe(chap);
      // Carte active = la dernière dont le haut a franchi 65 % de la hauteur d'écran.
      // Calcul au défilement : aucun « trou » entre deux cartes, contrairement à un observateur.
      var tick = false;
      function mesurer() {
        tick = false;
        if (!chapVisible) return;
        var seuil = window.innerHeight * 0.65, idx = -1;
        for (var i = 0; i < cartes.length; i++) { if (cartes[i].getBoundingClientRect().top < seuil) idx = i; else break; }
        if (idx !== actif) activer(idx);
      }
      window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(mesurer); } }, { passive: true });
      window.addEventListener('resize', mesurer);
      activer(-1);
      requestAnimationFrame(function () { chapVisible = chap.getBoundingClientRect().top < window.innerHeight; mesurer(); });
    });
  }

  /* ------------------------------------------------------------------
     Repères : points d'intérêt cliquables avec zoom vers le point
  ------------------------------------------------------------------ */
  function initReperes(root) {
    $$('[data-lv-reperes]', root).forEach(function (sec) {
      if (!once(sec, 'rep')) return;
      var image = sec.querySelector('.lv-reperes__image');
      var points = $$('.lv-point', sec);
      var panneaux = $$('.lv-panneau', sec);
      function fermer() {
        sec.classList.remove('is-zoomed');
        points.forEach(function (p) { p.setAttribute('aria-expanded', 'false'); });
        panneaux.forEach(function (p) { p.classList.remove('is-open'); p.setAttribute('aria-hidden', 'true'); });
      }
      points.forEach(function (p) {
        p.addEventListener('click', function () {
          var deja = p.getAttribute('aria-expanded') === 'true';
          fermer();
          if (deja) return;
          p.setAttribute('aria-expanded', 'true');
          var panneau = document.getElementById(p.getAttribute('aria-controls'));
          if (panneau) { panneau.classList.add('is-open'); panneau.setAttribute('aria-hidden', 'false'); }
          if (image && !sansMouvement()) {
            image.style.transformOrigin = p.style.left + ' ' + p.style.top;
            sec.classList.add('is-zoomed');
          }
        });
      });
      panneaux.forEach(function (pn) {
        var b = pn.querySelector('.lv-panneau__fermer');
        if (b) b.addEventListener('click', fermer);
      });
      sec.addEventListener('keydown', function (e) { if (e.key === 'Escape') fermer(); });
    });
  }

  /* ------------------------------------------------------------------
     Cycle de vie : curseur + boutons d'étape
  ------------------------------------------------------------------ */
  function initCycles(root) {
    $$('[data-lv-cycle]', root).forEach(function (sec) {
      if (!once(sec, 'cycle')) return;
      var visuels = $$('.lv-cycle__visuel', sec);
      var etapes = $$('.lv-cycle__etape', sec);
      var boutons = $$('.lv-cycle__reperes button', sec);
      var range = sec.querySelector('.lv-cycle__range');
      function aller(i) {
        i = Math.max(0, Math.min(etapes.length - 1, i));
        visuels.forEach(function (v, j) { v.classList.toggle('is-active', j === i); });
        etapes.forEach(function (v, j) { v.classList.toggle('is-active', j === i); });
        boutons.forEach(function (b, j) { if (j === i) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current'); });
        if (range && parseInt(range.value, 10) !== i) range.value = i;
        if (range) range.setAttribute('aria-valuetext', (boutons[i] && boutons[i].textContent.trim()) || String(i + 1));
      }
      if (range) range.addEventListener('input', function () { aller(parseInt(range.value, 10)); });
      boutons.forEach(function (b, i) { b.addEventListener('click', function () { aller(i); }); });
      aller(0);
    });
  }

  /* ------------------------------------------------------------------
     Bande horizontale : sur grand écran, le défilement vertical la fait glisser
  ------------------------------------------------------------------ */
  /* Hauteur de l'en-tête du thème quand il reste visible au défilement (fixe ou collant) :
     ce qui s'épingle se place dessous plutôt que derrière. */
  function hautEntete() {
    // Showcase rend collante l'enveloppe de section qui contient #site-control, pas #site-control lui-même
    for (var e = document.getElementById('site-control'); e && e !== document.body; e = e.parentElement) {
      var pos = getComputedStyle(e).position;
      if (pos === 'fixed' || pos === 'sticky') return Math.round(e.getBoundingClientRect().height);
    }
    return 0;
  }

  function initBandes(root) {
    $$('[data-lv-bande]', root).forEach(function (sec) {
      if (!once(sec, 'bande')) return;
      var piste = sec.querySelector('.lv-bande__piste');
      if (!piste) return;
      var mq = window.matchMedia('(min-width: 1000px)');
      var ticking = false;
      function mesurer() {
        var epingler = mq.matches && !sansMouvement() && sec.hasAttribute('data-lv-epingler');
        sec.classList.toggle('is-pinned', epingler);
        if (!epingler) { piste.style.transform = ''; sec.style.removeProperty('--lv-bande-h'); return; }
        var deborde = Math.max(0, piste.scrollWidth - window.innerWidth);
        var haut = hautEntete();
        // la bande reste épinglée sous l'en-tête pendant tout le défilement horizontal
        sec.style.setProperty('--lv-haut', haut + 'px');
        sec.style.setProperty('--lv-bande-h', (window.innerHeight - haut + deborde) + 'px');
        sec.__lvDeborde = deborde;
        sec.__lvHaut = haut;
        maj();
      }
      function maj() {
        ticking = false;
        if (!sec.classList.contains('is-pinned')) return;
        var r = sec.getBoundingClientRect();
        var haut = sec.__lvHaut || 0;
        var total = sec.offsetHeight - (window.innerHeight - haut);
        var p = total > 0 ? Math.min(1, Math.max(0, (haut - r.top) / total)) : 0;
        piste.style.transform = 'translate3d(' + (-p * (sec.__lvDeborde || 0)) + 'px,0,0)';
      }
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(maj); } }, { passive: true });
      window.addEventListener('resize', mesurer);
      if (mq.addEventListener) mq.addEventListener('change', mesurer);
      $$('img', piste).forEach(function (im) { if (!im.complete) im.addEventListener('load', mesurer, { once: true }); });
      mesurer();
    });
  }

  /* ------------------------------------------------------------------
     Photo en profondeur : parallaxe WebGL à partir d'une carte de profondeur
  ------------------------------------------------------------------ */
  var VS = 'attribute vec2 p;varying vec2 uv;void main(){uv=p*0.5+0.5;uv.y=1.0-uv.y;gl_Position=vec4(p,0.0,1.0);}';
  var FS = [
    'precision mediump float;',
    'uniform sampler2D img;uniform sampler2D prof;uniform vec2 dec;uniform vec2 ech;uniform float force;uniform float foyer;',
    'varying vec2 uv;',
    'void main(){',
    '  vec2 c=(uv-0.5)*ech+0.5;',
    '  float d=texture2D(prof,c).r;',
    '  vec2 q=c+dec*(d-foyer)*force;',
    '  gl_FragColor=texture2D(img,clamp(q,0.001,0.999));',
    '}'
  ].join('');

  function initProfondeurs(root) {
    $$('[data-lv-profondeur]', root).forEach(function (sec) {
      if (!once(sec, 'prof')) return;
      if (sansMouvement()) return;
      var srcImg = sec.getAttribute('data-lv-image');
      var srcProf = sec.getAttribute('data-lv-carte');
      if (!srcImg || !srcProf) return;
      var demarre = false;
      var obs = new IntersectionObserver(function (e) {
        if (e[0].isIntersecting && !demarre) { demarre = true; obs.disconnect(); lancer(); }
      }, { rootMargin: '30% 0px' });
      obs.observe(sec);

      function charger(src) {
        return new Promise(function (ok, ko) {
          var im = new Image(); im.crossOrigin = 'anonymous'; im.decoding = 'async';
          im.onload = function () { ok(im); }; im.onerror = ko; im.src = src;
        });
      }
      function lancer() {
        var canvas = document.createElement('canvas');
        var gl = canvas.getContext('webgl', { alpha: false, antialias: false, powerPreference: 'low-power' });
        if (!gl) return;
        Promise.all([charger(srcImg), charger(srcProf)]).then(function (ims) {
          var prog = gl.createProgram();
          [[gl.VERTEX_SHADER, VS], [gl.FRAGMENT_SHADER, FS]].forEach(function (s) {
            var sh = gl.createShader(s[0]); gl.shaderSource(sh, s[1]); gl.compileShader(sh); gl.attachShader(prog, sh);
          });
          gl.linkProgram(prog);
          if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) return;
          gl.useProgram(prog);
          var buf = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, buf);
          gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
          var loc = gl.getAttribLocation(prog, 'p'); gl.enableVertexAttribArray(loc); gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
          function tex(unit, im) {
            var t = gl.createTexture(); gl.activeTexture(gl.TEXTURE0 + unit); gl.bindTexture(gl.TEXTURE_2D, t);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
            gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, im);
          }
          tex(0, ims[0]); tex(1, ims[1]);
          gl.uniform1i(gl.getUniformLocation(prog, 'img'), 0);
          gl.uniform1i(gl.getUniformLocation(prog, 'prof'), 1);
          var uDec = gl.getUniformLocation(prog, 'dec'), uEch = gl.getUniformLocation(prog, 'ech');
          gl.uniform1f(gl.getUniformLocation(prog, 'force'), parseFloat(sec.getAttribute('data-lv-force')) || 0.035);
          gl.uniform1f(gl.getUniformLocation(prog, 'foyer'), parseFloat(sec.getAttribute('data-lv-foyer')) || 0.35);
          var ratioImg = ims[0].naturalWidth / ims[0].naturalHeight;
          function dimension() {
            var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
            var w = sec.clientWidth, h = sec.clientHeight;
            canvas.width = Math.round(w * dpr); canvas.height = Math.round(h * dpr);
            gl.viewport(0, 0, canvas.width, canvas.height);
            var ratioEcran = w / h, marge = 0.94; // léger recadrage pour cacher les bords déplacés
            if (ratioEcran > ratioImg) gl.uniform2f(uEch, marge, marge * ratioImg / ratioEcran);
            else gl.uniform2f(uEch, marge * ratioEcran / ratioImg, marge);
          }
          dimension();
          window.addEventListener('resize', dimension);
          var media = sec.querySelector('.lv-media');
          if (media) media.parentNode.insertBefore(canvas, media.nextSibling); else sec.insertBefore(canvas, sec.firstChild);
          sec.classList.add('is-3d');
          var cible = { x: 0, y: 0 }, cur = { x: 0, y: 0 }, pointeur = false, visible = true, t0 = performance.now();
          sec.addEventListener('pointermove', function (e) {
            if (e.pointerType === 'touch') return;
            var r = sec.getBoundingClientRect(); pointeur = true;
            cible.x = ((e.clientX - r.left) / r.width - 0.5) * 2; cible.y = ((e.clientY - r.top) / r.height - 0.5) * 2;
          });
          sec.addEventListener('pointerleave', function () { pointeur = false; });
          new IntersectionObserver(function (e) { visible = e[0].isIntersecting; if (visible) requestAnimationFrame(boucle); }).observe(sec);
          function boucle(t) {
            if (!visible) return;
            if (!pointeur) { var s = (t - t0) / 1000; cible.x = Math.sin(s * 0.35) * 0.7; cible.y = Math.cos(s * 0.27) * 0.35; }
            cur.x += (cible.x - cur.x) * 0.06; cur.y += (cible.y - cur.y) * 0.06;
            gl.uniform2f(uDec, -cur.x, -cur.y);
            gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
            requestAnimationFrame(boucle);
          }
          requestAnimationFrame(boucle);
        }).catch(function () {});
      }
    });
  }

  /* ------------------------------------------------------------------
     Navigation des chapitres (points à droite, barre en bas sur mobile)
  ------------------------------------------------------------------ */
  function initNav() {
    var chapitres = $$('[data-lv-nav-label]');
    var ancienne = document.querySelector('.lv-nav'); if (ancienne) ancienne.remove();
    var ancienneM = document.querySelector('.lv-nav-mobile'); if (ancienneM) ancienneM.remove();
    if (chapitres.length < 3 || !('IntersectionObserver' in window)) return;
    var nav = document.createElement('ol'); nav.className = 'lv-nav'; nav.setAttribute('aria-label', enAnglais ? 'Chapters' : 'Chapitres');
    var mob = document.createElement('div'); mob.className = 'lv-nav-mobile'; mob.innerHTML = '<div class="lv-nav-mobile__barre"></div><span></span>';
    var liens = chapitres.map(function (c, i) {
      if (!c.id) c.id = 'lv-chapitre-' + (i + 1);
      var li = document.createElement('li'), a = document.createElement('a');
      a.href = '#' + c.id; a.innerHTML = '<span></span>'; a.firstChild.textContent = c.getAttribute('data-lv-nav-label');
      a.addEventListener('click', function (e) { e.preventDefault(); c.scrollIntoView({ behavior: sansMouvement() ? 'auto' : 'smooth' }); });
      li.appendChild(a); nav.appendChild(li); return a;
    });
    document.body.appendChild(nav); document.body.appendChild(mob);
    var premier = chapitres[0], dernier = chapitres[chapitres.length - 1];
    var obs = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (!e.isIntersecting) return;
        var i = chapitres.indexOf(e.target);
        liens.forEach(function (a, j) { a.setAttribute('aria-current', j === i ? 'true' : 'false'); });
        mob.lastChild.textContent = (i + 1) + ' / ' + chapitres.length + ' · ' + e.target.getAttribute('data-lv-nav-label');
      });
    }, { rootMargin: '-50% 0px -50% 0px' });
    chapitres.forEach(function (c) { obs.observe(c); });
    var barre = mob.firstChild, tick = false;
    function maj() {
      tick = false;
      var debut = premier.getBoundingClientRect().top + window.scrollY;
      var fin = dernier.getBoundingClientRect().bottom + window.scrollY - window.innerHeight;
      var p = (window.scrollY - debut) / Math.max(1, fin - debut);
      var dedans = p > -0.02 && p < 1.02;
      nav.classList.toggle('is-visible', dedans); mob.classList.toggle('is-visible', dedans);
      barre.style.width = (Math.min(1, Math.max(0, p)) * 100) + '%';
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(maj); } }, { passive: true });
    maj();
  }

  /* ------------------------------------------------------------------
     Photothèque : filtres par catégorie + visionneuse plein écran
  ------------------------------------------------------------------ */
  var vis = null, visListe = [], visIdx = 0;
  function construireVisionneuse() {
    if (vis) return vis;
    vis = document.createElement('dialog');
    vis.className = 'lv-visionneuse';
    vis.setAttribute('aria-label', enAnglais ? 'Photo viewer' : 'Visionneuse de photos');
    vis.innerHTML =
      '<div class="lv-visionneuse__haut"><span class="lv-visionneuse__compte"></span>' +
      '<div class="lv-visionneuse__outils"><a class="lv-visionneuse__dl" hidden download target="_blank" rel="noopener">' + T.telecharger + '</a>' +
      '<button type="button" class="lv-visionneuse__fermer" aria-label="' + T.fermer + '">&times;</button></div></div>' +
      '<div class="lv-visionneuse__scene"></div>' +
      '<button type="button" class="lv-visionneuse__prec" aria-label="' + T.prec + '">&#8249;</button>' +
      '<button type="button" class="lv-visionneuse__suiv" aria-label="' + T.suiv + '">&#8250;</button>' +
      '<div class="lv-visionneuse__bas"><span class="lv-visionneuse__legende"></span><small class="lv-visionneuse__credit"></small></div>';
    document.body.appendChild(vis);
    vis.querySelector('.lv-visionneuse__fermer').addEventListener('click', fermerVis);
    vis.querySelector('.lv-visionneuse__prec').addEventListener('click', function () { montrer(visIdx - 1); });
    vis.querySelector('.lv-visionneuse__suiv').addEventListener('click', function () { montrer(visIdx + 1); });
    vis.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') montrer(visIdx - 1);
      else if (e.key === 'ArrowRight') montrer(visIdx + 1);
    });
    vis.addEventListener('close', function () { var v = vis.querySelector('video'); if (v) v.pause(); document.documentElement.style.overflow = ''; });
    var x0 = null;
    var scene = vis.querySelector('.lv-visionneuse__scene');
    scene.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    scene.addEventListener('touchend', function (e) {
      if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 50) montrer(visIdx + (dx < 0 ? 1 : -1));
    });
    scene.addEventListener('click', function (e) { if (e.target === scene) fermerVis(); });
    return vis;
  }
  function fermerVis() { if (vis && vis.open) vis.close(); }
  function montrer(i) {
    if (!visListe.length) return;
    visIdx = (i + visListe.length) % visListe.length;
    var el = visListe[visIdx];
    var scene = vis.querySelector('.lv-visionneuse__scene');
    scene.innerHTML = '';
    var video = (petitEcran() && lectureHls() && el.getAttribute('data-lv-video-hls')) || el.getAttribute('data-lv-video-src');
    if (video) {
      var v = document.createElement('video'); v.src = video; v.controls = true; v.autoplay = true; v.playsInline = true; v.loop = true;
      scene.appendChild(v);
    } else {
      var im = document.createElement('img');
      im.src = el.getAttribute('data-lv-plein'); im.alt = el.getAttribute('data-lv-alt') || '';
      scene.appendChild(im);
    }
    vis.querySelector('.lv-visionneuse__compte').textContent = (visIdx + 1) + ' ' + T.sur + ' ' + visListe.length;
    vis.querySelector('.lv-visionneuse__legende').textContent = el.getAttribute('data-lv-legende') || '';
    vis.querySelector('.lv-visionneuse__credit').textContent = el.getAttribute('data-lv-credit') || '';
    var dl = vis.querySelector('.lv-visionneuse__dl');
    var src = el.getAttribute('data-lv-telecharger');
    if (src) { dl.hidden = false; dl.href = src; } else { dl.hidden = true; }
    // précharge la suivante
    var suiv = visListe[(visIdx + 1) % visListe.length];
    if (suiv && suiv.getAttribute('data-lv-plein')) { var pre = new Image(); pre.src = suiv.getAttribute('data-lv-plein'); }
  }
  function initPhototheque() {
    var sections = $$('[data-lv-cat]');
    if (!sections.length) return;
    $$('.lv-mur__bouton').forEach(function (b) {
      if (!once(b, 'mur')) return;
      b.addEventListener('click', function () {
        visListe = $$('.lv-mur__bouton').filter(function (x) { return !x.closest('[hidden]'); });
        construireVisionneuse();
        document.documentElement.style.overflow = 'hidden';
        if (vis.showModal) vis.showModal(); else vis.setAttribute('open', '');
        montrer(visListe.indexOf(b));
        vis.querySelector('.lv-visionneuse__fermer').focus();
      });
    });
    var barre = document.querySelector('[data-lv-filtres]');
    if (!barre || !once(barre, 'filtres')) return;
    // La barre doit coller sur toute la photothèque : on sort son conteneur de la
    // section Shopify pour qu'il devienne un frère des sections dans <main>.
    $$('.lv-filtres-hote').forEach(function (h) { if (!h.contains(barre)) h.remove(); });
    var hote = barre.closest('.lv');
    var sectionShopify = hote && hote.closest('.shopify-section');
    if (sectionShopify && sectionShopify.parentNode) {
      hote.classList.add('lv-filtres-hote');
      sectionShopify.parentNode.insertBefore(hote, sectionShopify);
    }
    var cats = [];
    sections.forEach(function (s) {
      var id = s.getAttribute('data-lv-cat'), nom = s.getAttribute('data-lv-cat-nom') || id;
      var n = s.querySelectorAll('.lv-mur__item').length;
      var existe = cats.filter(function (c) { return c.id === id; })[0];
      if (existe) existe.n += n; else cats.push({ id: id, nom: nom, n: n });
    });
    var total = cats.reduce(function (a, c) { return a + c.n; }, 0);
    function bouton(id, nom, n) {
      var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-pressed', id === '*' ? 'true' : 'false');
      b.innerHTML = '<span></span><small></small>'; b.firstChild.textContent = nom; b.lastChild.textContent = n;
      b.addEventListener('click', function () {
        $$('button', barre).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        sections.forEach(function (s) { s.hidden = !(id === '*' || s.getAttribute('data-lv-cat') === id); });
        var cible = sections.filter(function (s) { return !s.hidden; })[0];
        if (cible && id !== '*') window.scrollTo({ top: barre.getBoundingClientRect().top + window.scrollY - 1, behavior: 'auto' });
        if (history.replaceState) history.replaceState(null, '', id === '*' ? location.pathname + location.search : '#' + id);
      });
      barre.appendChild(b); return b;
    }
    bouton('*', barre.getAttribute('data-lv-tout') || T.tout, total);
    var parId = {};
    cats.forEach(function (c) { parId[c.id] = bouton(c.id, c.nom, c.n); });
    var hash = decodeURIComponent(location.hash.slice(1));
    if (hash && parId[hash]) parId[hash].click();
    // Décale la barre sous l'en-tête du thème s'il reste visible au défilement
    if (hote) hote.style.top = hautEntete() + 'px';
  }

  /* ------------------------------------------------------------------ */
  function initTout(root) {
    initVideos(root); initReveal(root); initChapitres(root); initReperes(root);
    initCycles(root); initBandes(root); initProfondeurs(root);
  }
  function demarrer() { initTout(document); initNav(); initPhototheque(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer); else demarrer();
  document.addEventListener('shopify:section:load', function (e) { initTout(e.target); initNav(); initPhototheque(); });
})();
